module.exports = __webpack_public_path__ + "img/game_detail_rolling10_regular.2a722db3.jpg";